(function () {
  var config = window.AMG_ACCOUNTS || {};
  var accountsUrl = config.url || "https://accounts.audiomediagrading.com";
  var apiUrl = config.apiUrl || "https://project-rf949.vercel.app";
  var customerApi = window.AMGCustomer;

  function clearCookie(name) {
    document.cookie =
      name + "=; domain=.audiomediagrading.com; path=/; max-age=0; SameSite=Lax; Secure";
    document.cookie = name + "=; path=/; max-age=0; SameSite=Lax; Secure";
  }

  function logCustomerSession(profile, loggedIn) {
    if (!customerApi) return;
    var ctx = customerApi.getContext();
    console.group("[AMG] Customer session");
    console.log("loggedIn:", loggedIn);
    console.log("accountsUrl:", accountsUrl);
    console.log("customer:", ctx);
    console.groupEnd();
  }

  function setHeaderState(loggedIn, profile) {
    var loggedInBlocks = document.querySelectorAll(".amg-header-state--logged-in");
    var loggedOutBlocks = document.querySelectorAll(".amg-header-state--logged-out");
    var header = document.querySelector(".section-header");

    loggedInBlocks.forEach(function (block) {
      block.hidden = !loggedIn;
    });
    loggedOutBlocks.forEach(function (block) {
      block.hidden = loggedIn;
    });

    if (header) {
      header.classList.toggle("amg-customer-logged-in", loggedIn);
    }

    if (loggedIn && profile) {
      document.querySelectorAll("[data-amg-customer-initial]").forEach(function (el) {
        el.textContent = profile.initials || "?";
      });
      document.querySelectorAll(".menu-drawer__account[data-amg-drawer-account]").forEach(function (link) {
        link.textContent = profile.initials || "?";
      });
    }

    document.querySelectorAll(".cart__login-title, .cart__login-paragraph").forEach(function (el) {
      el.style.display = loggedIn ? "none" : "";
    });
  }

  function onLogout(event) {
    event.preventDefault();
    var token = customerApi ? customerApi.getToken() : null;
    var done = function () {
      if (customerApi) {
        clearCookie(customerApi.TOKEN_COOKIE);
        clearCookie(customerApi.PROFILE_COOKIE);
      }
      window.location.reload();
    };
    if (!token) {
      done();
      return;
    }
    fetch(apiUrl + "/api/customer/logout", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }).finally(done);
  }

  function initHeader() {
    var profile = customerApi ? customerApi.getProfile() : null;
    var loggedIn = !!profile;
    var loginUrl = config.loginUrl || accountsUrl + "/login";
    var accountUrl = config.accountUrl || accountsUrl + "/account";

    document.querySelectorAll(".amg-header-state--logged-out .header__icon--account").forEach(function (link) {
      link.href = loginUrl;
    });
    document.querySelectorAll(".amg-header-state--logged-in .header__icon--account").forEach(function (link) {
      link.href = accountUrl;
    });
    document.querySelectorAll(".menu-drawer__account[href]").forEach(function (link) {
      if (link.closest(".amg-header-state--logged-out")) link.href = loginUrl;
      if (link.closest(".amg-header-state--logged-in")) link.href = accountUrl;
    });

    setHeaderState(loggedIn, profile);
    logCustomerSession(profile, loggedIn);

    document.querySelectorAll(".amg-accounts-logout").forEach(function (link) {
      link.addEventListener("click", onLogout);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHeader);
  } else {
    initHeader();
  }
})();
